import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66b71312"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-title row wrap" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Product References ")
const _hoisted_3 = { class: "q-pa-lg q-mt-md column" }
const _hoisted_4 = { class: "row justilfy-between col-12" }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddButton = _resolveComponent("AddButton")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_EditProductMenu = _resolveComponent("EditProductMenu")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_AddOrUpdateProductReferencePopin = _resolveComponent("AddOrUpdateProductReferencePopin")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_card, { class: "q-mb-lg" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              (_ctx.isUserAdmin)
                ? (_openBlock(), _createBlock(_component_AddButton, {
                    key: 0,
                    "data-test": "add-product-reference-button",
                    "popin-type": _ctx.popinTypeEnum.PRODUCT_REFERENCE
                  }, null, 8 /* PROPS */, ["popin-type"]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_q_separator),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("dl", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductReferences, (productReference) => {
              return (_openBlock(), _createElementBlock("dt", {
                key: productReference.id,
                class: "product-reference q-mb-lg"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("a", {
                    href: productReference.linkUrl,
                    target: "_blank",
                    class: "q-pt-sm col-9",
                    "data-test": "reference-href"
                  }, _toDisplayString(productReference.linkTitle), 9 /* TEXT, PROPS */, _hoisted_5),
                  (_ctx.isUserAdmin)
                    ? (_openBlock(), _createBlock(_component_EditProductMenu, {
                        key: 0,
                        class: "col-2",
                        onOnEdit: ($event: any) => (_ctx.onClickEditProductReference(productReference)),
                        onOnDelete: ($event: any) => (_ctx.onDeleteProductReference(productReference))
                      }, null, 8 /* PROPS */, ["onOnEdit", "onOnDelete"]))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_AddOrUpdateProductReferencePopin, {
      "is-edit-mode": _ctx.isEditMode,
      "current-product-reference": _ctx.currentProductReference,
      onOnClose: _ctx.onClosePopin
    }, null, 8 /* PROPS */, ["is-edit-mode", "current-product-reference", "onOnClose"]),
    _createVNode(_component_ConfirmDialog, {
      title: "Delete Reference",
      message: _ctx.confirmDeleteReferenceMessage,
      open: _ctx.displayConfirmDeleteDialog,
      onOnClose: _ctx.onClose,
      onOnConfirm: _ctx.onConfirmDelete
    }, null, 8 /* PROPS */, ["message", "open", "onOnClose", "onOnConfirm"])
  ]))
}